export const emptyScriptPricing = () => ({ enabled: false, price: '' })

export function scriptPricingForm(config) {
  return { enabled: config?.enabled === true, price: Number.isInteger(config?.price_minor) && config.price_minor > 0 ? (config.price_minor / 100).toFixed(2) : '' }
}

export function scriptPricingPayload(form, isScript) {
  const enabled = isScript && form?.enabled === true
  const text = String(form?.price ?? '').trim().replace(',', '.')
  let price_minor = null
  if (text) {
    if (!/^\d+(\.\d{1,2})?$/.test(text)) {
      if (enabled) throw new Error('Enter a USD total with up to two decimal places')
    } else {
      const [whole, fraction = ''] = text.split('.')
      price_minor = Number(whole) * 100 + Number(fraction.padEnd(2, '0'))
      if (!Number.isSafeInteger(price_minor) || price_minor <= 0 || price_minor > 1000000) {
        if (enabled) throw new Error('The total must be between USD 0.01 and USD 10,000')
        price_minor = null
      }
    }
  }
  if (enabled && price_minor === null) throw new Error('Set the whole-script price before enabling prepaid use')
  return { enabled, price_minor, currency: 'USD' }
}
